import React from 'react';
import classnames from 'classnames';

import Link from 'components/atoms/Link';

import styles from './index.module.css';

interface TagProperty {
	className?: string;
	size?: 'medium' | 'small';
	tagId?: number;
	tagName?: string;
	hasLink?: boolean;
}

const Tag: React.FC<TagProperty> = ({ className, size, tagId, tagName, hasLink = false }) => {
	if (hasLink) {
		return (
			<Link
				className={classnames(styles.tag, styles[`size-${size}`], className)}
				to={`/tags/${tagId}`}
			>
				{tagName}
			</Link>
		);
	}

	return <div className={classnames(styles.tag, styles[`size-${size}`], className)}>{tagName}</div>;
};

export default Tag;
